export const DEFAULT_VIEW_MODE = "grouped_by_demand";
export const GROUPED_BY_DEMAND = "grouped_by_demand";
export const GROUPED_BY_SUPPLY = "grouped_by_supply";
export const GROUPED_BY_CONSTRAINTS = "grouped_by_constraints";
export const QUICK_ACTIVITY_VIEW = "quick_activity_view";
export const CURRENT_GROUP_ONLY_VIEW = "current_group_only_view";
export const POSITION_VIEW = "position";
